import { ChangeDetectionStrategy, Component, inject, input, InputSignal, Signal, signal, WritableSignal } from '@angular/core';
import { ExpanderContentComponent } from '@libs/common/components';
import { IconComponent } from '@libs/components/icons';
import { CapabilityService } from '@libs/shared/services';
import { CartCalculationSummaryModel, MinimumOrderValueModel } from '@libs/shop/models';
import { ProductPriceFormatterComponent } from '../../../catalog/product-prices/product-price-formatter';

@Component({
  selector: 'ui-order-overview-details',
  templateUrl: './order-overview-details.component.html',
  styleUrls: ['./order-overview-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ProductPriceFormatterComponent,
    ExpanderContentComponent,
    IconComponent,
  ],
})
export class OrderOverviewDetailsComponent {
  public data: InputSignal<CartCalculationSummaryModel> = input.required();
  public minimumOrderValue: InputSignal<MinimumOrderValueModel | undefined> = input();

  public showMinimumOrderValue: WritableSignal<boolean> = signal(false);
  public showDeposit: WritableSignal<boolean> = signal(false);
  public showTaxes: WritableSignal<boolean> = signal(false);

  public readonly capabilityService: CapabilityService = inject(CapabilityService);

  public orderExtendedDepositEnabled: Signal<boolean> = this.capabilityService.isAvailable('shop.orderExtendedDeposit');

  public toggleShow(show: WritableSignal<boolean>): void {
    show.set(!show());
  }
}
